import { TEasInfoItem } from 'redux/reducers/easInfo/types';
import { TEasInfoTableRow } from './types';

export const createStableRowId = (name: string): number => {
	let hash = 0;
	for (let i = 0; i < name.length; i += 1) {
		hash = (hash * 31 + name.charCodeAt(i)) | 0;
	}
	return Math.abs(hash) || 1;
};

export const mapEasInfoToTableRows = (items: TEasInfoItem[]): TEasInfoTableRow[] =>
	items.map((item) => ({
		...item,
		id: createStableRowId(item.name),
	}));
